module.exports = __webpack_public_path__ + "media/images/logo/payment_channel/virtual_account_bni-70bf82166fee08e9fb78e1a4dd7699b8.svg";